import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "isDark", "isAnimated", "children"];
import styled, { keyframes } from 'styled-components';
import parseClassnames from "../helpers/parseClassnames";
import { baseLighter24, baseLighter56, grayLight, grayMain } from "../styles/colors";
import { jsx as _jsx } from "react/jsx-runtime";
var placeHolderShimmer = /*#__PURE__*/keyframes(["\n  from {\n    background-position: 100% 0\n  }\n  to {\n    background-position: -100% 0\n  }\n"]);
var AnimatedSkeleton = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-4x7fgg-0"
})(["\n  animation-duration: 1.5s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: ", ";\n  animation-timing-function: linear;\n  background: ", ";\n  background-size: 200% 100%;\n"], placeHolderShimmer, function (_ref) {
  var isDark = _ref.isDark;
  return isDark ? "linear-gradient(to right, ".concat(baseLighter56, " 8%, ").concat(baseLighter24, " 18%, ").concat(baseLighter56, " 33%)") : "linear-gradient(to right, ".concat(grayLight, " 8%, ").concat(grayMain, " 18%, ").concat(grayLight, " 33%)");
});
var Skeleton = function Skeleton(_ref2) {
  var _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    isDark = _ref2.isDark,
    isAnimated = _ref2.isAnimated,
    children = _ref2.children,
    skeletonProps = _objectWithoutProperties(_ref2, _excluded);
  if (isAnimated) {
    return (
      /*#__PURE__*/
      // @ts-ignore
      _jsx(AnimatedSkeleton, _objectSpread(_objectSpread({
        className: className,
        isDark: isDark
      }, skeletonProps), {}, {
        children: children
      }))
    );
  }
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    className: parseClassnames(className, isDark ? 'bg-gray-main-dark-mode' : 'bg-gray-light')
  }, skeletonProps), {}, {
    children: children
  }));
};
export default Skeleton;